"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_jss_1 = __importDefault(require("react-jss"));
// auto-install
const jss_1 = require("./jss");
jss_1.install();
function withStyles(styles, options) {
    return react_jss_1.default(styles, Object.assign({ injectTheme: options && options.injectTheme }, options));
}
exports.withStyles = withStyles;
